import endpoints from '@/api/endpoints';
import moment from 'moment';
import API from '../../api/callApi.js';


export default {
    namespaced: true,
    state: {
        customers: null,
        dataLoaded: false,
        customerFilters: {
            search: null,
            selectedSegments: []
        },

        registration: {
            processing: false,
            error: null
        }
    },
    mutations: {
        setCustomerData(state, value) {
            state.customers = value;
        },
        setDataLoaded(state, value) {
            state.dataLoaded = value;
        },
        setDbFilterSearch(state, value) {
            if (value === "") {
                value = null;
            }
            state.customerFilters.search = value;
        },
        setDbFilterSegments(state, value) {
            let index = state.customerFilters.selectedSegments.indexOf(value);

            if (index > -1) {
                state.customerFilters.selectedSegments.splice(index, 1);
            } else {
                state.customerFilters.selectedSegments.push(value);
            }

        },

        /*
        ** CUSTOMER REGISTRATION
        */

        setRegistrationProcess(state, value) {
            state.registration.processing = value;
        },
        setRegistrationError(state, value) {
            state.registration.error = value;
        },
        deleteCustomer(state, id) {
            const index = state.customers.findIndex(row => row.id === id)
            if (index > -1) {
              state.customers.splice(index, 1)
            }
        }
    },
    actions: {
        exportAllCustomers(state) {
            API.exportAllCustomers(state.state.customerFilters.selectedSegments).then(response => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `${
                    new Date().getTime()
                }.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
                state.commit('ui/hideloader', null, {root: true})
                state.commit('ui/snackbar', {
                    display: true,
                    label: 'tous les clients sont exportées',
                    duration: 2000,
                    mode: 'success'
                }, {root: true})
            }).catch(error => {
                state.commit('ui/hideloader', null, {root: true})
                state.commit('ui/snackbar', {
                    display: true,
                    label: 'erreur lors de d\'exportation des clients',
                    duration: 2000,
                    mode: 'danger'
                }, {root: true})
            })
        },
        importClientsFromCsv(state, csvContent) {
            state.commit('ui/cloader', {
                display: true,
                label: 'importation en cours'
            }, {root: true});
            const delimeter = ";"
            const lines = csvContent.split("\r" + "\n");
            const headers = lines[0].split(delimeter);
            const result = []
            for (let cmp = 1; cmp < lines.length; cmp++) {
                let obj = {}
                let line = lines[cmp]
                let re = /"/g
                line = re[Symbol.replace](line, '')
                if (! line) {
                    continue
                }
                line = line.split(delimeter)
                for (let jmp = 0; jmp < line.length; jmp++) {
                    const key = headers[(jmp > 4 ? 4 : jmp)].trim()
                    const value = line[jmp]
                    if (key === "segments") {
                        if (!(key in obj)) obj[key] = []
                        obj[key].push(value)
                    } else {
                        obj[key] = value
                    }
                }
                result.push(obj)
            }

            const hideLoader = () => state.commit('ui/hideloader', null, {root: true})
            API.importClientsFromCsv(result).then(() => {
                state.dispatch('customer/loadCustomerData', state, {root: true});
                state.commit('ui/snackbar', {
                    display: true,
                    label: 'clients importées',
                    duration: 2000,
                    mode: 'success'
                }, {root: true})
            }).catch((error) => {
                hideLoader()
                state.commit('ui/snackbar', {
                    display: true,
                    label: 'Erreur lors de l\'importation des clients',
                    duration: 3000,
                    mode: 'danger'
                }, {root: true})
            })

        },
        async loadCustomerData(state) {
            state.commit('ui/cloader', {
                display: true,
                label: ''
            }, {root: true});
            await API.makeGet(endpoints.baseURL + endpoints.endpoints.customer, null, true).then(response => {
                response.data.payload.map((item, index) => {
                    item.id = item.id;
                    item.created_at = moment(item.created_at).format('DD/MM/YYYY');
                    item.average_visit_duration = item.average_visit_duration ? (item.average_visit_duration.hour !== undefined ? item.average_visit_duration.hour + 'H' + item.average_visit_duration.minute : '-') : '-';
                    item.nb_visits = item.nb_visits;
                    item.segments = item.segments;
                    item.optin = item.optin;
                });
                state.commit('setCustomerData', response.data.payload);
                state.commit('setDataLoaded', true);
                state.commit('ui/hideloader', null, {root: true})
            });
        },

        /*
        ** CUSTOMER REGISTRATION
        */

        registerCustomer(
            {
                state,
                commit
            },
            parameters
        ) {

            if (state.registration.processing) {
                return;
            }

            commit('setRegistrationProcess', true);

            API.makePost(endpoints.baseURL + endpoints.endpoints.registerCustomer, {
                'establishment_id': parameters.parameters.establishment_id,
                'firstname': parameters.parameters.firstname,
                'lastname': parameters.parameters.lastname,
                'email': parameters.parameters.email,
                'cellphone': parameters.parameters.cellphone,
                'submit_fidelity': parameters.parameters.submit_fidelity,
                'submit_covid': parameters.parameters.submit_covid,
                'submit_confidentiality': parameters.parameters.submit_confidentiality,
                'submit_cgu': parameters.parameters.submit_cgu,
                'session_key': parameters.parameters.session_key
            }, false).then(response => {
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Bienvenue dans votre espace client !'
                }, {root: true});
            }).catch(error => {
                commit('setRegistrationError', error);
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'Une erreur est survenue.'
                }, {root: true});
            }). finally(response => {
                commit('setRegistrationProcess', false);
            });

        },
        updateCustomer(
            {
                state,
                commit
            },
            payload
        ) {
            API.makePost(endpoints.baseURL + endpoints.endpoints.updateCustomerData, {
                'customer_id': payload.customer_id,
                'customer': payload.customer,
            }, true).then(response => {
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Client mis à jour'
                }, {root: true});
            }).catch(error => {
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'Une erreur est survenue.'
                }, {root: true});
            })

        },
        updateCustomerSegments(
            {
                state,
                commit
            },
            payload
        ) {
            API.makePost(endpoints.baseURL + endpoints.endpoints.updateCustomerSegments, {
                'customer_id': payload.customer_id,
                'segments': payload.segments,
            }, true).then(response => {
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Client mis à jour'
                }, {root: true});
            }).catch(error => {
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'Une erreur est survenue.'
                }, {root: true});
            })

        },
        deleteCustomers({commit}, payload) {
            const ids = payload.map(({id}) => id)
            API.makeDelete(endpoints.baseURL + endpoints.endpoints.deleteCustomers, {ids}, true)
                .then(response => {
                    response.data.payload.map(id => commit('deleteCustomer', id))
                    commit('ui/triggerAlert', {
                        type: 'success',
                        msg: 'Clients supprimés avec succès'
                    }, { root: true });
                }).catch(error => {
                    commit('ui/triggerAlert', {
                        type: 'error',
                        msg: 'Une erreur est survenue.'
                    }, { root: true });
                })
        }
    }
};
